import React from "react";
import { FormControl } from "react-bootstrap";
import SearchIcon from "@mui/icons-material/Search";

const CandidateSearchFilter = ({
  searchText,
  setSearchText,
  selectedJobId,
  setSelectedJobId,
  getJobdata,
}) => {
  return (
    <div className="search-container d-flex flex-column flex-md-row gap-2 mt-1 mb-2">
      <div className="d-flex w-100 position-relative">
        <FormControl
          type="text"
          placeholder="Search by name or designation"
          className="w-100 pe-0"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />
        <SearchIcon
          className="search-icon text-white sset position-absolute"
          style={{
            cursor: "pointer",
            right: "10px",
            top: "50%",
            transform: "translateY(-50%)",
          }}
        />
      </div>

      {getJobdata && getJobdata.length > 0 && (
        <div className="w-100 w-md-50">
          <FormControl
            as="select"
            value={selectedJobId}
            onChange={(e) => setSelectedJobId(e.target.value)}
            className="w-100"
          >
            <option value="">All Jobs</option>
            {getJobdata.map((job) => (
              <option key={job._id} value={job._id}>
                {job.title}
              </option>
            ))}
          </FormControl>
        </div>
      )}
    </div>
  );
};

export default CandidateSearchFilter;
